import { ListItemButton, ListItemIcon, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { SidebarNavItemIconProps } from '../../props';

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  zIndex: 1201,
  padding: '0rem 1.5rem',
  '& :link': {
    backgroundColor: alpha(theme.palette.common.white, 0.08)
  },
  '&.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.04)
  },
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.common.white, 0.08)
  },
  '&.MuiListItemButton-root:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.04)
  }
}));

export const StyledListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => !['level', 'iconSelectedColor', 'activeModule'].includes(prop as string)
})<Omit<SidebarNavItemIconProps, 'theme'>>(({ level, iconSelectedColor }) => ({
  minWidth: level === 1 ? 36 : 18,
  color: iconSelectedColor
}));
